import { useEffect, useState } from 'react';
import { COOKIE_CONSENT } from './constants';
import { getCookieConsent, type CookieChoice } from './index';

/**
 * `true` só depois de o usuário permitir a categoria. Começa `false` (também
 * no servidor) e reage a mudanças feitas pelo aviso ou pelo link do rodapé.
 */
export const useCookieConsent = (category: keyof CookieChoice): boolean => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const sync = () => setAllowed(getCookieConsent()?.[category] === true);
    sync();
    window.addEventListener(COOKIE_CONSENT.changedEvent, sync);
    return () => window.removeEventListener(COOKIE_CONSENT.changedEvent, sync);
  }, [category]);

  return allowed;
};

export default useCookieConsent;
